import { FC, ReactNode } from "react";
import { Document, Font, Page, StyleSheet, View } from "@react-pdf/renderer";

import SourceSerifPro from "../../../../assets/fonts/Source_Serif_Pro_BirfFonts/Source-Serif-Pro.ttf";
import Poppins from "../../../../assets/fonts/Poppins_BirdFonts/Poppins-Black.ttf";
import ManropeUltra from "../../../../assets/fonts/Manrope_BirdFonts/Manrope-ExtraBold.ttf";
import ManropeSemi from "../../../../assets/fonts/Manrope_BirdFonts/Manrope-SemiBold.ttf";

type Props = {
  header?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
};

Font.register({
  family: "SourceSerifPro",
  src: SourceSerifPro,
  fontWeight: "normal",
  format: "truetype",
});

Font.register({
  family: "Poppins",
  src: Poppins,
  fontWeight: "heavy",
  format: "truetype",
});

Font.register({
  family: "Manrope",
  fonts: [
    { src: ManropeUltra, fontWeight: "ultrabold", format: "truetype" },
    { src: ManropeSemi, fontWeight: "semibold", format: "truetype" },
  ],
});

const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  wrapper: {
    backgroundColor: "#ffffff",
    display: "flex",
    height: "88vh",
    flexDirection: "column",
    justifyContent: "space-between",
    rowGap: 24,
  },
  content: {
    flexGrow: 1,
  },
});

export const DocumentWrapper: FC<Props> = ({ header, children, footer }) => {
  return (
    <Document>
      <Page style={styles.body}>
        <View style={styles.wrapper}>
          {header}
          <View style={styles.content}>{children}</View>
          {footer}
        </View>
      </Page>
    </Document>
  );
};
